import DM from 'DM';

const AnalyticsPlugin = {
    install(Vue) {
        if (!Vue.prototype.$ga) {
            Vue.prototype.$ga = {
                trackEvent({ category, action, label = null, value = null, nonInteractive = false, fn = () => { } }) {
                    DM.Utils.trackEvents(category, action, label, value, nonInteractive, fn);
                },
                trackGTM(data) {
                    DM.Utils.trackGTM(data);
                }
            };
        }
    }
};

export { AnalyticsPlugin };
